var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcon3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128.27 155.62",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#040405;}.cls-2{fill:#d7006c;}.cls-3{fill:#fff;}.cls-4{fill:none;stroke:#e13333;stroke-miterlimit:10;}.cls-5{fill:#161615;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_426",
    "data-name": "Path 426",
    className: "cls-1",
    d: "M77.81,155.62h-28c-61.31,0-53.72-94.15-41.11-133.7A49.92,49.92,0,0,1,49.81,0h28a49.41,49.41,0,0,1,31.51,11.36,52.16,52.16,0,0,1,4.08,3.78c13.06,13.48,14.09,34.38,14.53,52.06.5,20.31,1.64,41.94-7.12,60.85-5.84,12.62-15.16,22-33,26.55a49.08,49.08,0,0,1-10,1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_427",
    "data-name": "Path 427",
    className: "cls-2",
    d: "M28.7,10.21a64.42,64.42,0,0,1,7-3.32c25.53-10.34,51.25-2,65.58,4.42"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_428",
    "data-name": "Path 428",
    className: "cls-3",
    d: "M47.18,8.58A28.21,28.21,0,0,1,50.42,7c11.85-4.8,23.79-.92,30.45,2.05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_429",
    "data-name": "Path 429",
    className: "cls-3",
    d: "M63.52,41.35c0,15.56-11-.79-26.57-.79s-29.8,16.35-29.8.79a28.19,28.19,0,1,1,56.37,0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_430",
    "data-name": "Path 430",
    className: "cls-4",
    d: "M63.52,41.35c0,15.56-11-.79-26.57-.79s-29.8,16.35-29.8.79a28.19,28.19,0,1,1,56.37,0Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_431",
    "data-name": "Path 431",
    className: "cls-5",
    d: "M53.35,40.72c0,10.75-5.21.7-16,.7s-23,10-23-.7a19.47,19.47,0,1,1,38.93-.28v.28"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_432",
    "data-name": "Path 432",
    className: "cls-3",
    d: "M37.9,29.47a6.37,6.37,0,1,1-6.37-6.37h0a6.37,6.37,0,0,1,6.37,6.37"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_433",
    "data-name": "Path 433",
    className: "cls-2",
    d: "M54.16,52.94C53.43,54,43.11,49.1,28,51.56c-7.36,1.2-11.93,3.51-12.6,2.71-.87-1,5.17-6.66,13-8.49C41.68,42.7,55,51.66,54.16,52.94"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_434",
    "data-name": "Path 434",
    className: "cls-3",
    d: "M123.42,41.35c0,15.56-11-.79-26.57-.79s-29.8,16.35-29.8.79a28.19,28.19,0,1,1,56.37,0"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_435",
    "data-name": "Path 435",
    className: "cls-4",
    d: "M123.42,41.35c0,15.56-11-.79-26.57-.79s-29.8,16.35-29.8.79a28.19,28.19,0,1,1,56.37,0Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_436",
    "data-name": "Path 436",
    className: "cls-5",
    d: "M113.24,40.72c0,10.75-5.21.7-16,.7s-23,10-23-.7a19.47,19.47,0,0,1,38.93-.29v.29"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_437",
    "data-name": "Path 437",
    className: "cls-3",
    d: "M97.8,29.47a6.37,6.37,0,1,1-6.37-6.37h0a6.37,6.37,0,0,1,6.37,6.37"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_438",
    "data-name": "Path 438",
    className: "cls-2",
    d: "M114.05,52.94c-.72,1.07-11-3.84-26.17-1.38-7.36,1.2-11.92,3.51-12.6,2.71-.86-1,5.17-6.66,13-8.49,13.27-3.08,26.61,5.88,25.74,7.16"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon3);
export default __webpack_public_path__ + "static/media/Icon3.9dbea6ec9f7f1b7689f1d3791f2dc797.svg";
export { ForwardRef as ReactComponent };